// Angular
import { Component, OnInit } from "@angular/core";
// Models

import { Tournament } from "./../../models/tournament";
// Services
import { AngularFireDatabase } from "angularfire2/database";
import { FormGroup, FormControl, Validators } from "@angular/forms";

import { ApiService } from "./../../services/api";
import * as lodash from "lodash";
import { OAuthService } from "./../../services/o-auth";
import { Club } from "./../../models/club";
import { ActivatedRoute, Router } from "@angular/router";
import { resolve } from "url";

@Component({
  templateUrl: "./scorecards.component.html",
})
export class ScorecardsComponent implements OnInit {
  public scorecardCountList: Array<any>;
  public scorecardCount = 0;
  public imageLoader: boolean = true;
  public filterargs: any;

  constructor(
    private router: Router,
    private fireDatabase: AngularFireDatabase,
    private apiService: ApiService,
    private oAuthService: OAuthService,
    private route: ActivatedRoute
  ) {
    let clubDetails = JSON.parse(localStorage.getItem("club"));
    if (clubDetails.cid.length < 13) {
      this.router.navigate(["/components/scorecards/", clubDetails.cid]);
    }
    this.scorecardCountList = [];
    this.filterargs = {
      item: {
        clubName: "",
      },
    };
  }

  ngOnInit() {
    return Promise.all([this.getScorecard(), this.getTournament()]).then(
      (res) => {
        this.imageLoader = false;
      }
    );
  }

  getTournament() {
    let promise = new Promise((resolve, reject) => {
      this.apiService.list(`/tournaments/`).then((result) => {
        lodash.forEach(result, (item1, teamKey) => {
          if (item1.leaderboard) {
            if (item1.teamPlay == 0) {
              lodash.forEach(item1.leaderboard, (team, teamKey) => {
                lodash.forEach(team, (player, playerUid) => {
                  if (playerUid !== "team") {
                    if (this.scorecardCountList.length) {
                      var i = -1;
                      for (i = 0; i < this.scorecardCountList.length; i++) {
                        var element = this.scorecardCountList[i];
                        if (element.item.cid == item1.cid) {
                          break;
                        }
                      }
                      if (i != this.scorecardCountList.length && i > -1) {
                        ++this.scorecardCountList[i].count;
                        if (item1.clubName) {
                          this.scorecardCountList[i].item = item1;
                        }
                      } else {
                        this.scorecardCountList.push({ item: item1, count: 1 });
                      }
                    } else {
                      this.scorecardCountList.push({ item: item1, count: 1 });
                    }
                    ++this.scorecardCount;
                  }
                });
              });
            }
            if (item1.teamPlay > 0) {
              lodash.forEach(item1.leaderboard, (team, teamKey) => {
                if (this.scorecardCountList.length) {
                  var i = -1;
                  for (i = 0; i < this.scorecardCountList.length; i++) {
                    var element = this.scorecardCountList[i];
                    if (element.item.cid == item1.cid) {
                      break;
                    }
                  }
                  if (i != this.scorecardCountList.length && i > -1) {
                    ++this.scorecardCountList[i].count;
                    if (item1.clubName) {
                      this.scorecardCountList[i].item = item1;
                    }
                  } else {
                    this.scorecardCountList.push({ item: item1, count: 1 });
                  }
                } else {
                  this.scorecardCountList.push({ item: item1, count: 1 });
                }
                ++this.scorecardCount;
              });
            }
          }
        });
        resolve(this.scorecardCount);
      });
    });
    return promise;
  }

  getScorecard() {
    let promise = new Promise((resolve, reject) => {
      this.apiService.list(`/scorecards/`).then((result) => {
        lodash.forEach(result, (item1, teamKey) => {
          if (item1.leaderboard) {
            lodash.forEach(item1.leaderboard, (team, teamKey) => {
              lodash.forEach(team, (player, playerUid) => {
                if (playerUid !== "team") {
                  if (this.scorecardCountList.length) {
                    var i = -1;
                    for (i = 0; i < this.scorecardCountList.length; i++) {
                      var element = this.scorecardCountList[i];
                      if (element.item.cid == item1.cid) {
                        break;
                      }
                    }
                    if (i != this.scorecardCountList.length && i > -1) {
                      ++this.scorecardCountList[i].count;
                    } else {
                      this.scorecardCountList.push({ item: item1, count: 1 });
                    }
                  } else {
                    this.scorecardCountList.push({ item: item1, count: 1 });
                  }
                  ++this.scorecardCount;
                }
              });
            });
          }
        });
        resolve(this.scorecardCount);
      });
    });
    return promise;
  }
}
